import { BaseSkeleton } from 'components/BaseSkeleton'
import { ChipWithInput } from 'components/chip-with-input'
import { ContextChip } from 'components/context-chip'
import { useTranslate, T } from 'lib/tolgee'

import { translations } from './context-list.i18n'
import './context-list.styles.scss'
import type { IContextList } from './context-list.types'

export function ContextListView({
  contexts,
  activeContext,
  isLoadingContext,
  hideCreateContext,
  hideTitle,
  hasReachedLimit,
  handleActiveContext,
  handleCreateContext,
}: IContextList) {
  const t = useTranslate()

  const titleTranslation = hideCreateContext ? translations.titleTotal : translations.title

  return (
    <div className="context-list">
      {!hideTitle && (
        <span className="context-list__title">
          <T keyName={titleTranslation.key}>{titleTranslation.defaultValue}</T>
        </span>
      )}
      <div className="context-list__chips">
        {isLoadingContext ? (
          Array.from({ length: 6 }).map((_, index) => (
            <BaseSkeleton key={`ContextListSkeleton-chip-${index}`} height={50} width={140} borderRadius={24} />
          ))
        ) : (
          <>
            {contexts.map(context => (
              <ContextChip
                key={context.id}
                icon={context.icon}
                isActive={context.id === activeContext.id}
                onClick={() => handleActiveContext(context.id)}
                onClose={context.onClose && (() => context.onClose(context.id))}
              >
                {context.name}
              </ContextChip>
            ))}
            {!hasReachedLimit && !hideCreateContext && (
              <ChipWithInput placeholderText={t(translations.createNewContext)} onSubmit={handleCreateContext} />
            )}
          </>
        )}
      </div>
    </div>
  )
}
